export * from './supported-media-formats'

export const FULL_DATE_FORMAT = 'dd-MM-yyyy HH:mm'
export const TIME_DATE_FORMAT = 'HH:mm'
export const SHORT_DATE_FORMAT = 'dd-MM-yyyy'
